import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';

import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf],
})
export class SpinnerComponent implements OnInit, OnDestroy {

  @Input() name: string;

  private _show = false;
  @Input()
  get show(): boolean { return this._show; }
  set show(value: boolean) {
    if (this._show !== value) {
      this._show = value;
      this.ngZone.runOutsideAngular(() => {
        Promise.resolve().then(() => this.cdr.detectChanges());
      });
    }
  }

  constructor(private spinnerService: SpinnerService, private cdr: ChangeDetectorRef, private ngZone: NgZone) { }

  ngOnInit(): void {
    if (!this.name) {
      throw new Error("Please provide Spinner name");
    }

    this.spinnerService._register(this);
  }

  ngOnDestroy(): void {
    this.spinnerService._unregister(this);
  }

}
